import { getBaseUrl, getRequestWithTokenInformation } from "services/common";
import { parseTemplate } from "url-template";
import { RequestInit } from "atoms/models";

const channelGuideTemplate = parseTemplate("ecommerce/monday/channels/{company}");

export const getChannelGuideListings = async (company: string) => {
  const baseUrl = getBaseUrl();
  const relativeUrl = channelGuideTemplate.expand({ company });
  const input = new URL(relativeUrl, baseUrl).href;
  const headers = new Headers();
  headers.append("Accept", "application/json");
  const init: RequestInit = getRequestWithTokenInformation("GET", headers);
  const response = await window.fetch(input, init);
  const json = await response.json();
  return json;
};
